export default __webpack_public_path__ + "static/media/wedding_mansion_logo.a7b3cd79.jpg";